import { ReactElement } from "react";
import { ListTableColumn, renderEnumValue } from "sprint-common-web";

import { DeliveryEndpointType } from "../types/DeliveryEndpointType";

export const renderDeliveryEndpointType = <T,>(
    item?: T,
    _index?: number,
    column?: ListTableColumn<T>
): ReactElement | null => {
    return renderEnumValue(DeliveryEndpointType, item, _index, column);
};
